// Values come from assets/env.js, which each Kubernetes environment replaces via the cpd-ui/env.js pod annotation.
const runtimeEnv = (globalThis as any).__env || {};

export const environment = {
  production: true,
  environmentName: runtimeEnv.environmentName,
  serviceURL: runtimeEnv.serviceURL,
  auth: {
    issuer: `https://login.microsoftonline.com/${runtimeEnv.tenantId}/v2.0`,
    clientId: runtimeEnv.clientId,
    redirectUri: location.origin,
    postLogoutRedirectUri: location.origin,
    responseType: "code",
    scope: `openid profile email ${runtimeEnv.clientId}/.default`,
    showDebugInformation: true,
    strictDiscoveryDocumentValidation: false,
    customQueryParams: { domain_hint: runtimeEnv.domainHint },
    silent_redirect_uri: location.origin,
    silentRefreshShowIFrame: false,
    timeoutFactor: 0.5,
  },
};
